import React from 'react';
import './specializations.css';

import html from '../../images/html.png';
import css from '../../images/css.png';
import tailwindcss from '../../images/tailwindcss.png';
import sass from '../../images/sass.png';
import js from '../../images/js.png';
import react from '../../images/react.png';
import reactrouter from '../../images/reactrouter.png';
import nextjs from '../../images/nextjs.png';

export default function Specializations() {

  return (
    <section id="Specializations">
        <div className="spec--container">
            <h1>Specializations</h1>
            <div className="spec--text">
                <div className='d-flex flex-column gap-5'>
                    <div className='d-flex gap-4 align-items-center'>
                        <a href="https://en.wikipedia.org/wiki/HTML" target='_blank' rel='noreferrer'>
                            <img src={html} width='50em' alt='HTML5'/>
                        </a>
                        <p>HTML 5</p>
                    </div>
                    <div className='spec--gap d-flex align-items-center'>
                        <div className='d-flex gap-4 align-items-center'>
                            <a href="https://en.wikipedia.org/wiki/CSS" target='_blank' rel='noreferrer'>
                                <img src={css} width='50em' alt='CSS3'/>
                            </a>
                            <p>CSS 3</p>
                        </div>
                        <div className='d-flex gap-4 align-items-center'>
                            <a href="https://tailwindcss.com" target='_blank' rel='noreferrer'>
                                <img src={tailwindcss} width='50em' alt='TailwindCSS'/>
                            </a>
                            <p>TailwindCSS</p>
                        </div>
                        <div className='d-flex gap-4 align-items-center'>
                            <a href="https://sass-lang.com" target='_blank' rel='noreferrer'>
                                <img src={sass} width='50em' alt='SASS'/>
                            </a>
                            <p>Sass</p>
                        </div>
                    </div>
                    <div className='d-flex gap-4 align-items-center'>
                        <a href="https://en.wikipedia.org/wiki/JavaScript" target='_blank' rel='noreferrer'>
                            <img src={js} width='50em' alt='Javascript'/>
                        </a>
                        <p>Javascript</p>
                    </div>
                    <div className='d-flex align-items-center spec--gap'>
                        <div className='d-flex gap-4 align-items-center'>
                            <a href="https://reactjs.org" target='_blank' rel='noreferrer'>
                                <img src={react} width='50em' alt='React.js'/>
                            </a>
                            <p>React.js</p>
                        </div>
                        <div className='d-flex gap-4 align-items-center'>
                            <a href="https://nextjs.org" target='_blank' rel='noreferrer'>
                                <img src={nextjs} width='50em' alt='Next.js'/>
                            </a>
                            <p>Next.js</p>
                        </div>
                        <div className='d-flex gap-4 align-items-center'>
                            <a href="https://reactrouter.com/en/main" target='_blank' rel='noreferrer'>
                                <img src={reactrouter} width='50em' alt='React Router'/>
                            </a>
                            <p>React Router</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}
